"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.create.title': '创建机器人测试',
};
